import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import qs from 'qs';

import CreditList from '../components/CreditList/CreditList';
import Pagination from '../components/Pagination/Pagination';
import { fetchUserCredit } from '../actions/credit';
import userPage from '../decorators/userPage';
import { getUserCredits, getPageCount, getIsAdmin } from '../reducers';

class UserCredit extends Component {
  componentDidMount() {
    this.fetchCredit();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.userId !== this.props.userId) {
      this.fetchCredit();
    }

    if (oldProps.page !== this.props.page) {
      this.fetchCredit();
    }
  }

  fetchCredit() {
    const { fetchUserCredit, userId, page } = this.props;
    fetchUserCredit(userId, page);
  }

  render() {
    const { user, userId, credits, pageCount, page, isAdmin } = this.props;
    if (!user) {
      return <div>Loading...</div>;
    }

    if (!credits) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <div className="flex-justify-space-between flex-align-center">
          <h1>Credits</h1>
          {isAdmin && (
            <Link to={`/users/${user.id}/credits/create`}>
              <button className="btn btn-default">Create Credit</button>
            </Link>
          )}
        </div>
        <CreditList credits={credits} />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/users/${userId}/credits?page=${pageNum}`}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    isAdmin: getIsAdmin(state),
    credits: getUserCredits(state, page),
    pageCount: getPageCount(state, 'credit', `fetchByUser`, page),
    page,
  };
};

const mapDispatchToProps = {
  fetchUserCredit,
};

export default compose(
  withRouter,
  userPage,
  connect(mapStateToProps, mapDispatchToProps),
)(UserCredit);
